import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Stack,
  TextField,
  Alert,
  Card,
  CardContent,
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import saveNotification from "../../../api/notification/saveNotification";
import getNotifications from "../../../api/notification/getNotifications";
import deleteNotification from "../../../api/notification/deleteNotification";
import getNotificationContent from "../../../api/notification/getNotificationContent";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";



function NotificationSetting() {
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [newsId, setNewsId] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [date, setDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const toolbarOptions = [
    [{ size: ["small", false, "large", "huge"] }], // custom dropdown

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    ["link", "image", "video"],

    ["clean"], // remove formatting button
  ];

  const modules = {
    toolbar: {
      container: toolbarOptions,
    },
  };

  const fetchNotifications = async () => {
    try {
      const data = await getNotifications();
      setNotifications(data.notifications || []);
    } catch (err) {
      setError("Failed to load notifications: " + err.message);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleSaveNotification = async () => {
    try {
      const notificationDate = new Date(date);
      const notificationStartDate = new Date(startDate);
      const notificationEndDate = new Date(endDate);

      const response = await saveNotification(
        newsId,
        title,
        content,
        notificationDate,
        notificationStartDate,
        notificationEndDate
      );

      setIsSuccess(true);
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        {
          Id: response.id, // Assuming the response contains the new notification's ID
          Title: title,
          Content: "",
          Date: notificationDate,
          StartDate: notificationStartDate,
          EndDate: notificationEndDate,
        },
      ]);
      fetchNotifications();
      setNewsId("");
      setTitle("");
      setContent("");
      setDate("");
      setStartDate("");
      setEndDate("");
      console.log("Notification set successfully:", response);
    } catch (err) {
      setIsSuccess(false);
      setError("Failed to set notification: " + err.message);
    }
  };

  const handleDeleteNotification = async (notification) => {
    try {
      await deleteNotification(notification.Id);

      setNotifications((prevNotifications) =>
        prevNotifications.filter((n) => n.Id !== notification.Id)
      );
      setNewsId("");
      setTitle("");
      setContent("");
      setDate("");
      setStartDate("");
      setEndDate("");
    } catch (err) {
      setError("Failed to delete notification: " + err.message);
    }
  };

  const handleViewContent = async (notification) => {
    try {
      const content = await getNotificationContent(notification.Id);
      setNewsId(notification.Id);
      setContent(content);
      setTitle(notification.Title);
      setDate(new Date(notification.Date).toISOString().split("T")[0]);
      setStartDate(new Date(notification.StartDate).toISOString().slice(0, 16));
      setEndDate(new Date(notification.EndDate).toISOString().slice(0, 16));
    } catch (err) {
      setError("Failed to fetch content: " + err.message);
    }
  };

  return (
    <div>
      <Card sx={{ margin: 1 }}>
        <CardContent>
          <Stack height={"70vh"} direction="row" spacing={1} width={"100%"}>
            <Box minWidth={"25%"} maxWidth={"25%"}>
              <Stack direction={"row"} spacing={1}>
                <Typography variant="h5">最新消息</Typography>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => {
                    setNewsId("");
                    setTitle("");
                    setContent("");
                    setDate("");
                    setStartDate("");
                    setEndDate("");
                  }}
                >
                  新增
                </Button>
              </Stack>
              <List

                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                  position: "relative",
                  overflow: "auto",
                  height: "70vh",
                  "& ul": { padding: 0 },
                  
                }}
              >
                {notifications?.map((notification, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      border: 1,
                      borderColor: "gray",
                      boxShadow: 3,
                      marginTop:1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      paddingRight: 0, // Ensure space between button and delete icon
                    }}
                  >
                    <Button
                      sx={{
                        color: "black",
                        width: "100%",
                        textAlign: "left",
                        justifyContent: "flex-start",
                        padding: 0,
                        textTransform: "none",
                      }}
                      onClick={() => handleViewContent(notification)}
                    >
                      <ListItemText
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap", // Use 'nowrap' if you want the text to stay in one line, else use 'normal' or 'pre-wrap' for multiline
                        }}
                        primary={notification.Title}
                        secondary={
                          <>
                            {new Date(notification.Date).toLocaleDateString()}
                            <br />
                            {new Date(
                              notification.StartDate
                            ).toLocaleDateString()}{" "}
                            -{" "}
                            {new Date(
                              notification.EndDate
                            ).toLocaleDateString()}
                          </>
                        }
                      />
                    </Button>
                    <IconButton

                      aria-label="delete"
                      onClick={() => handleDeleteNotification(notification)}
                    >
                      <Delete />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </Box>
            <Stack direction={"column"} spacing={1} flex={1}>
              <TextField
                label="標題"
                color="secondary"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                fullWidth
              />
              <Stack direction="row" spacing={1}>
                <TextField
                  label="日期"
                  variant="outlined"
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
                <TextField
                  label="開始時間"
                  variant="outlined"
                  type="datetime-local"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
                <TextField
                  label="結束時間"
                  variant="outlined"
                  type="datetime-local"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Stack>
              <ReactQuill

                value={content}
                modules={modules}
                style={{ height: "40vh", marginBottom: "20px" }}
                onChange={setContent}
              />
              <Box paddingTop={5} display={"flex"} justifyContent={"right"}>
                {" "}
                <Button
                  variant="contained"
                  color="info"
                  onClick={handleSaveNotification}
                >
                  儲存
                </Button>
              </Box>
            </Stack>
          </Stack>
          {isSuccess && (
            <Alert sx={{ marginTop: 7 }} severity="success">
              操作成功！
            </Alert>
          )}
          {error && (
            <Alert sx={{ marginTop: 7 }} severity="error">
              {error}
            </Alert>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default NotificationSetting;
